import * as React from 'react'
import { MatchPairProps } from './typings'
import { BillToMatch } from './BillToMatch'
import { ServiceLocationMatch } from './ServiceLocationMatch'

export const MatchPair: React.FC<MatchPairProps> = (props) =>
  props.location.billingLocation ? (
    <BillToMatch {...props} />
  ) : (
    <ServiceLocationMatch {...props} />
  )
MatchPair.displayName = 'MatchPair'
